import { doc, updateDoc } from "firebase/firestore";
import { FIRESTORE_USERS_TABLE } from "../../../constants/FirebaseConstants";
import { useAuthContext } from "../../../context/AuthContext";
import { auth, db } from "../../../services/firebase";
import { sendExceptionToSlack } from "../../../services/api/exception";

export function useUser() {
  const { authUser } = useAuthContext();

  const updateUser = async (object) => {
    if (!authUser) {
      return;
    }
    const userDocRef = doc(db, FIRESTORE_USERS_TABLE, authUser.uid);
    try {
      return await updateDoc(userDocRef, object);
    } catch (err) {
      console.error(err);
      sendExceptionToSlack(
        `useUser hook - updateUser: uid=${authUser.uid}, object=${JSON.stringify(object)}, error=${err.message}`,
      );
    }
  };

  const logout = async () => {
    try {
      await auth.signOut();
    } catch (err) {
      console.error(err);
      sendExceptionToSlack("useUser hook - signOut: ", err);
    }
  };

  return { updateUser, logout };
}
